import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

export default function RankList() {
  const ranked = [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, 6);

  return (
    <div className="flex h-full flex-col rounded-lg border border-background-200/80 bg-background-100 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-900">
          <span className="flex h-6 w-6 items-center justify-center rounded bg-primary-600/90 text-background-50">
            <i className="ri-fire-line text-[13px]"></i>
          </span>
          本周热门榜
        </h3>
        <span className="font-label text-[10px] uppercase tracking-[0.2em] text-foreground-500">Top 6</span>
      </div>

      <ol className="flex flex-1 flex-col divide-y divide-background-200/70">
        {ranked.map((movie, index) => (
          <li key={movie.id}>
            <Link to={`/detail/${movie.id}`} className="group flex items-center gap-3 py-3">
              <span
                className={`w-5 shrink-0 font-heading text-lg font-semibold leading-none ${
                  index < 3 ? "text-primary-400" : "text-foreground-500"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
              <span className="relative h-[62px] w-[44px] shrink-0 overflow-hidden rounded border border-background-300/60">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 海报`}
                  title={`${movie.title} ${movie.year} 剧情介绍`}
                  className="h-full w-full object-cover object-top"
                />
              </span>
              <span className="min-w-0 flex-1">
                <span className="block truncate text-[13.5px] font-medium text-foreground-800 transition-colors group-hover:text-primary-200">
                  {movie.title}
                </span>
                <span className="mt-0.5 block truncate text-[11px] text-foreground-500">
                  {movie.year} · {movie.country} · {movie.genres.join("/")}
                </span>
              </span>
              <span className="flex shrink-0 items-center gap-1 font-label text-[11px] text-secondary-300">
                <i className="ri-star-fill text-[10px] text-primary-400"></i>
                {movie.rating.toFixed(1)}
              </span>
            </Link>
          </li>
        ))}
      </ol>

      <Link
        to="/category/伦理"
        className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md border border-background-300/70 py-2.5 text-[12px] text-foreground-600 transition-colors hover:border-primary-500 hover:text-primary-200"
      >
        查看完整分类
        <i className="ri-arrow-right-line text-[13px]"></i>
      </Link>
    </div>
  );
}